import { ROUTE_PATHS } from "@/constants/routes";

export const CONVERSATION_QUERY_PARAM = "conversationId";
export const CONVERSATION_MODAL_ID = "conversation-dialog";

const PARAM_CHANGE_EVENT = "casastep:conversation-param";

export function readConversationParam() {
  if (typeof window === "undefined") return null;
  return new URLSearchParams(window.location.search).get(
    CONVERSATION_QUERY_PARAM,
  );
}

export function setConversationParam(conversationId: string | null) {
  if (typeof window === "undefined") return;

  const url = new URL(window.location.href);
  if (!url.pathname.endsWith(ROUTE_PATHS.CHAT)) return;
  if (conversationId) {
    url.searchParams.set(CONVERSATION_QUERY_PARAM, conversationId);
  } else {
    url.searchParams.delete(CONVERSATION_QUERY_PARAM);
  }

  window.history.replaceState(
    window.history.state,
    "",
    `${url.pathname}${url.search}`,
  );
  window.dispatchEvent(new Event(PARAM_CHANGE_EVENT));
}

export function subscribeConversationParam(onChange: () => void) {
  window.addEventListener("popstate", onChange);
  window.addEventListener(PARAM_CHANGE_EVENT, onChange);
  return () => {
    window.removeEventListener("popstate", onChange);
    window.removeEventListener(PARAM_CHANGE_EVENT, onChange);
  };
}
